import { computed, inject, Injectable, signal } from "@angular/core";
import { AlertService } from "@ui";
import Keycloak from "keycloak-js";

@Injectable({ providedIn: "root" })
export class UserProfileService {
  readonly #keycloak = inject(Keycloak);
  readonly #alertService = inject(AlertService);
  readonly #profile = signal<Keycloak.KeycloakProfile | undefined>(undefined);

  readonly profile = this.#profile.asReadonly();
  readonly email = computed(() => this.#profile()?.email);

  /** Resolves with the profile once loaded; rejects if the load fails. */
  readonly ready: Promise<Keycloak.KeycloakProfile> = this.#keycloak.loadUserProfile().then((profile) => {
    this.#profile.set(profile);
    return profile;
  });

  constructor() {
    // Also prevents an unhandled rejection when no consumer awaits `ready`.
    this.ready.catch((error) => {
      console.error("Could not load user profile", error);
      this.#alertService.error("Could not load your user profile. Some actions may be unavailable.");
    });
  }
}
